<template>
  <div class="exercise">
    <div class="back" @click="$router.go(-1)">
      <i class="el-icon-back"></i> <span>返回上一页</span>
    </div>
    <el-tabs v-model="activeName" type="card">
      <el-tab-pane label="运动" name="first">
        <el-table :data="tableData" :border="true">
          <el-table-column
            label="序号"
            width="80"
            align="center"
            type="index"
            prop=""
          >
          </el-table-column>
          <el-table-column label="测量时间" align="center" prop="DayTimestamp">
            <template slot-scope="scope" align="center">
              {{ scope.row.DayTimestamp | handtime }}
            </template>
          </el-table-column>
          <el-table-column label="设备型号" align="center" prop="DeviceType">
            <template slot-scope="scope" align="center">
              {{ scope.row.DeviceType || "-" }}
            </template>
          </el-table-column>
          <el-table-column label="运动方式" align="center" prop="SportType">
            <template slot-scope="scope" align="center">
              {{ scope.row.SportType==2 ? "室外跑步" :scope.row.SportType==1?"室内跑步":"室外散步" }}
            </template>
          </el-table-column>
          <el-table-column label="运动时长" align="center" prop="Duration">
            <template slot-scope="scope" align="center">
              {{ scope.row.Duration | handSportTime }}
            </template>
          </el-table-column>
          <el-table-column label="运动里程" align="center" prop="RunningDistance">
            <template slot-scope="scope" align="center">
              {{ scope.row.RunningDistance | RunningDistancehand  }}
            </template>
          </el-table-column>
          <el-table-column label="步数" align="center" prop="StepNum">
            <template slot-scope="scope" align="center">
              {{ scope.row.StepNum || "-" }}
            </template>
          </el-table-column>
          <el-table-column label="平均配速" align="center" prop="Speed">
            <template slot-scope="scope" align="center">
              {{ scope.row.Speed | handSpeed }}
            </template>
          </el-table-column>
          <el-table-column label="消耗热量" align="center" prop="Heat">
            <template slot-scope="scope" align="center">
              {{ scope.row.Heat || "-" }}
            </template>
          </el-table-column>
          <el-table-column label="平均心率" align="center" prop="AverageHeartRate">
            <template slot-scope="scope" align="center">
              {{ scope.row.AverageHeartRate || "-" }}
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          layout="->,total,prev, pager, next"
          :total="total"
          :current-page="page"
          @current-change="changefn"
          :page-size="size"
        >
        </el-pagination>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { requestUserSportData } from "@/api/userApi";
import { handtime } from "@/utils/util";
export default {
  name: "exercise",
  data() {
    return {
      activeName: "first",
      page: 1,
      size: 10,
      total: 0,
      tableData: [
        {
          date: 111,
        },
      ],
    };
  },
  created() {
    this.requestUserSportDatafn();
  },
  filters: {
    handtime,
    handSportTime(time){
       if(time){
        var s = time %60 >9 ? time %60 :"0" + time %60 
        var m= Math.floor(time/ 60) %24 >9? Math.floor(time/ 60) %24 : "0" + Math.floor(time/ 60) %24
        var h= Math.floor(time/60/24) >9 ? Math.floor(time/60/24) : "0" +Math.floor(time/60/24)
         return  h+":" +m+":"+ s

       }else{
         return "-"
       }

    },
    RunningDistancehand(m){
      return (m/1000).toFixed(3) + "km"
    },
    handSpeed(time){
      if(time){
        var s= time %60 >9 ? time %60 :"0" + time %60 
        var m= Math.floor(time/ 60) %24 >9? Math.floor(time/ 60) %24 : "0" + Math.floor(time/ 60) %24
        return `${m}'${s}"` 


      }else{
        return "-"
      }

    }
  },
  methods: {
    changefn(index){
      this.page =index;
      this.requestUserSportDatafn();

    },
    async requestUserSportDatafn() {
      var res = await requestUserSportData({
        userId: this.$route.query.id,
        page: this.page,
        size: this.size,
      });
      this.tableData = res.data.data.result.list;
      this.total = res.data.data.result.count;
    },
  },
};
</script>

<style lang="less">
.exercise {
  padding: 15px;
  position: relative;
  .back {
    position: absolute;
    right: 40px;
    top: 15px;
    height: 40px;
    line-height: 40px;
    color: #4276ff;
    z-index: 999;
    cursor: pointer;
  }
  .el-table {
    margin-bottom: 20px;
  }
  thead tr .el-table__cell {
    background-color: #e3e3e3;
    color: #333;
  }
}
</style>